<script setup lang="ts">
import { ref, watch } from 'vue'
import { vMaska } from 'maska/vue'
import { SelectCards } from '@/modules/shared/components'
import { useWorkspaceOnboardingStore } from '../../stores/workspace-onboarding-store'
import { useWorkspaceSettingsStore } from '../../stores/workspace-settings-store'

const onboardingStore = useWorkspaceOnboardingStore()
const settingsStore = useWorkspaceSettingsStore()

const form = ref({
  is_registered_investment_advisor: false,
  central_registration_depository_number: '',
})

watch(
  () => onboardingStore.workspace,
  (ws) => {
    if (!ws) return
    form.value.is_registered_investment_advisor = ws.is_registered_investment_advisor ?? false
    form.value.central_registration_depository_number = ws.central_registration_depository_number ?? ''
  },
  { immediate: true },
)

const submit = async (): Promise<boolean> => {
  await settingsStore.updateWorkspace(
    {
      is_registered_investment_advisor: form.value.is_registered_investment_advisor,
      central_registration_depository_number: form.value.is_registered_investment_advisor
        ? form.value.central_registration_depository_number
        : '',
    },
    { silent: true },
  )
  await onboardingStore.fetch()
  return true
}

defineExpose({ submit })
</script>

<template>
  <div class="flex flex-1 flex-col">
    <SelectCards
      v-model="form.is_registered_investment_advisor"
      :options="[
        { label: 'Yes, we\'re an RIA', value: true, description: '' },
        { label: 'No', value: false, description: '' },
      ]"
      :columns="2"
    />

    <div v-if="form.is_registered_investment_advisor" class="mt-6">
      <label class="mb-1 block text-sm font-medium text-gray-700">CRD number</label>
      <p class="mb-2 text-xs text-gray-500">
        Your Central Registration Depository number from FINRA. You can find it on the SEC IAPD website.
      </p>
      <input
        v-model="form.central_registration_depository_number"
        v-maska
        data-maska="#######"
        type="text"
        inputmode="numeric"
        placeholder="e.g. 1234567"
        class="block w-full rounded-md border border-gray-300 shadow-sm focus:border-sky-300 focus:ring focus:ring-sky-200 focus:ring-opacity-50"
      />
    </div>
  </div>
</template>
